import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { Grid } from '@mui/material'
import TextField from './TextField'
import Select from './Select'
import { optionPrefix } from '../constant'
import DateSelect from './DateSelect'
import { Column } from 'src/components/Layout/Styled'
import Document from './Document'
import TitleInput from './TitleInput'
import useLocalStorage from '@rehooks/local-storage'
import _ from 'lodash'
import { userType } from 'src/components/UpdateProfileDialog/UpdateProfileForm/model'

const InformationItem = ({ index }) => {
  const [user] = useLocalStorage('user')
  const isAgent = user?.userType === userType.AGENT
  const staffType = _.get(user, 'staffProfile.type', null)
  const isStaffAcademy =
    user?.userType === userType.STAFF && staffType !== 'NON_ACADEMY'
  const isStaffNonAcademy =
    user?.userType === userType.STAFF && staffType === 'NON_ACADEMY'
  const isProspect = user?.userType === userType.PROSPECT

  const { editable } = useSelector(
    (state) => ({
      editable: state.classEnroll.enroll[index].editable,
    }),
    shallowEqual
  )

  // Determine required fields based on role
  // Agent: Only prefixTH required
  // Staff Academy: Only idCardNo and birthDate required
  // Staff Non Academy & Prospect: All fields required except email
  const isAllFieldsRequired = isStaffNonAcademy || isProspect
  const isPrefixTHRequired = isAgent || isAllFieldsRequired
  const isFirstNameTHRequired = isAllFieldsRequired
  const isLastNameTHRequired = isAllFieldsRequired
  const isPrefixRequired = isAllFieldsRequired
  const isFirstNameRequired = isAllFieldsRequired
  const isLastNameRequired = isAllFieldsRequired
  const isIdCardNoRequired = isStaffAcademy || isAllFieldsRequired
  const isMobileNoRequired = isAllFieldsRequired
  const isBirthDateRequired = isStaffAcademy || isAllFieldsRequired

  return (
    <Column sx={{ rowGap: 3 }}>
      <Grid container spacing={3}>
        <TitleInput
          index={index}
          obj="prefixTH"
          isDisabled={!editable.isEditPrefixTH}
          required={isPrefixTHRequired}
          md={4}
        />
        <TextField
          index={index}
          obj="firstNameTH"
          label="ชื่อ"
          isDisabled={!editable.isEditName}
          required={isFirstNameTHRequired}
          md={4}
          sm={6}
        />
        <TextField
          index={index}
          obj="lastNameTH"
          label="นามสกุล"
          isDisabled={!editable.isEditSurname}
          required={isLastNameTHRequired}
          sm={4}
        />
      </Grid>
      <Grid container spacing={3}>
        <Select
          index={index}
          obj="prefix"
          label="Title Name"
          options={optionPrefix}
          isDisabled={!editable.isEditPrefix}
          required={isPrefixRequired}
          md={4}
          sm={12}
        />
        <TextField
          index={index}
          obj="firstName"
          label="First Name"
          isDisabled={!editable.isEditNameEN}
          required={isFirstNameRequired}
          md={4}
          sm={6}
        />
        <TextField
          index={index}
          obj="lastName"
          label="Last Name"
          isDisabled={!editable.isEditSurnameEN}
          required={isLastNameRequired}
          sm={4}
        />
      </Grid>
      <Grid container spacing={3}>
        <TextField
          index={index}
          obj="idCardNo"
          label="บัตรประชาชน"
          isDisabled={!editable.isEditIdCardNo}
          required={isIdCardNoRequired}
          md={4}
          sm={12}
        />
        <DateSelect
          index={index}
          obj="birthDate"
          label="วัน เดือน ปี เกิด"
          disabled={!editable.isEditBirthDate}
          required={isBirthDateRequired}
          md={4}
          sm={6}
        />
        <TextField
          index={index}
          obj="mobileNo"
          label="หมายเลขโทรศัพท์มือถือ"
          isDisabled={!editable.isEditMobile}
          required={isMobileNoRequired}
          md={4}
        />
      </Grid>
      <Grid container spacing={3}>
        <TextField
          index={index}
          obj="email"
          label="อีเมล"
          isDisabled={true}
          md={4}
        />
      </Grid>
      <Grid container>
        <Document index={index} />
      </Grid>
    </Column>
  )
}

export default InformationItem
